<style lang="less" scoped>
.alpha-loading-wrapper {
  // display: inline-block;
  margin: 0 auto;
  position: relative;
  color: var(--ant-primary-color);
  .loader {
    position: relative;
    height: 100%;
    width: 100%;
  }
  .center-text {
    line-height: 100%;
    // height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 40px;
    &::before {
      line-height: inherit;
    }
  }
  .circle {
    // position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: rotate 2s linear infinite;
    transform-origin: center center;
    .loader-path {
      stroke-dasharray: 150, 200;
      stroke-dashoffset: -10;
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite, color 3s ease-in-out infinite;
    }
    @keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124;
      }
    }
  }
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
.
<template>
  <div v-if="loading" :style="heightStyle" class="block-loading-wrapper flex-center">
    <div :style="wrapperStyle" class="alpha-loading-wrapper">
      <div class="loader">
        <span :style="fontStyle" class="center-text ibass-alpha"></span>
        <svg class="circle" viewBox="25 25 50 50">
          <circle
            class="loader-path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke="#ED6C00"
            stroke-width="0.5"></circle>
        </svg>
      </div>
    </div>
  </div>
</template>
<script setup>
import { toRefs, computed } from 'vue'
// props | emits
const props = defineProps({
  loading: {
    type: Boolean,
    default: true
  },
  height: {
    type: [Number, String],
    default: 100
  },
  size: {
    type: [Number],
    default: 100
  }
})
const { loading, size, height } = toRefs(props)
function attrTrans(str, b = 1) {
  if (typeof str == 'number') {
    return str * b + 'px'
  } else {
    return str
  }
}
let wrapperStyle = computed(() => {
    return {
      width: attrTrans(size.value),
      height: attrTrans(size.value)
    }
  }),
  heightStyle = computed(() => {
    return {
      height: attrTrans(height.value)
    }
  }),
  fontStyle = computed(() => {
    return {
      fontSize: attrTrans(size.value, 0.4)
    }
  })
</script>
